import * as XLSX from 'xlsx';

export interface ColumnDef {
  label: string;
  key: string;
}

export function exportToExcel(
  data: Record<string, any>[],
  columns: ColumnDef[],
  filename: string
): void {
  const rows = data.map((row) =>
    Object.fromEntries(columns.map(({ label, key }) => [label, row[key] ?? '']))
  );
  const ws = XLSX.utils.json_to_sheet(rows);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
  XLSX.writeFile(wb, `${filename}.xlsx`);
}

export function readExcelFile(file: File): Promise<Record<string, any>[]> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = (e) => {
      const data = new Uint8Array(e.target!.result as ArrayBuffer);
      const wb = XLSX.read(data, { type: 'array', cellDates: true });
      const ws = wb.Sheets[wb.SheetNames[0]];
      // defval: "" ensures every row has all column keys (empty cells are "" not missing)
      // raw: false formats dates/numbers as display strings instead of serial numbers
      resolve(XLSX.utils.sheet_to_json(ws, { defval: "", raw: false }));
    };
    reader.onerror = reject;
    reader.readAsArrayBuffer(file);
  });
}
